import { createFileRoute } from '@tanstack/react-router'
import { ChatHistoryList } from '../../../../components/ChatHistory'

export const Route = createFileRoute('/desa/$slug/dashboard/riwayat')({
  component: () => {
    const { desaId } = Route.useRouteContext() as { desaId: string }
    if (!desaId) return null
    return <ChatHistoryList desaId={desaId} />
  },
})
